import { useEffect, useState } from "react";

import { api } from "@/api";
import { Arrow } from "@/components/landing/icons";
import { GoogleLogo, Stars } from "@/components/ReviewsSection";

export function LandingReviews() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/public/reviews").then(({ data: d }) => setData(d)).catch(() => {}); }, []);
  const hasRating = data && Number(data.rating) > 0;
  return (
    <div className="lp-bezel lp-rvbox lp-rv" data-testid="reviews-section">
      <div className="lp-core">
        <div>
          <span className="lp-eyebrow">Avis clients</span>
          <h2 className="lp-rvtitle">Ils nous ont fait <em>confiance</em></h2>
        </div>
        {hasRating && (
          <div className="lp-rvtop" data-testid="reviews-summary">
            <span className="lp-score" data-testid="reviews-rating">{Number(data.rating).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}</span>
            <div>
              <Stars value={Number(data.rating)} size={18} />
              <p className="lp-m"><GoogleLogo size={14} /> Note moyenne sur Google{data.count > 0 && <> · <span data-testid="reviews-count">{data.count} avis</span></>}</p>
            </div>
          </div>
        )}
        {data?.url && <a href={data.url} target="_blank" rel="noopener noreferrer" className="lp-btn lp-sm lp-dark" data-testid="reviews-google-link">Voir les avis sur Google<span className="lp-ico"><Arrow /></span></a>}
      </div>
    </div>
  );
}
